// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".crumbs[data-v-f231a188]{text-align:right}.crumbs .right[data-v-f231a188]{font-size:15px;line-height:17px;color:#6e6e6e;padding:22px 0}.crumbs .right span[data-v-f231a188]{padding:0 5px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
